import React from "react";
import styled from "styled-components";
import { faEnvelope, faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp, faInstagram } from "@fortawesome/free-brands-svg-icons";

const ContactUI = styled.section`
  display: flex;
  padding: 50px 30px;
  width: 100%;
  justify-content: center;
  background-color: var(--black);
  color: white;
  overflow: hidden;
  gap: 150px;

  iframe {
    height: 250px;
    width: 400px;
    border: 0;
  }
  @media (max-width: 1260px) {
    gap: 80px;

    iframe {
      width: 320px;
    }
  }
  @media (max-width: 1100px) {
    gap: 50px;
  }
  @media (max-width: 992px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    flex-direction: column;
  }
  @media (max-width: 500px) {
    iframe {
      width: 90%;
    }
  }
`;

export const ContactColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media (max-width: 992px) {
    text-align: center;
  }
`;

export const ContactTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  font-family: var(--raleway);
  color: var(--red);
`;

export const ContactSubtitle = styled.h4`
  font-size: 16px;
  font-family: var(--raleway);
`;

export const ContactParagraph = styled.p`
  font-size: 1rem;
  font-weight: 400;
  color: var(--white);
  font-family: var(--roboto);
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 992px) {
    justify-content: center;
  }
`;

const LastParagraph = styled(ContactParagraph)`
  @media (max-width: 350px) {
    align-items: flex-start;
  }
`;

export const CarLogo = styled.img`
  margin-top: 30px;
  @media (max-width: 1260px) {
    width: 320px;
  }
  @media (max-width: 576px) {
    width: 90%;
    margin-top: 50px;
    align-self: center;
  }
`;

const Contact = () => {
  return (
    <>
      <ContactUI>
        <ContactColumn>
          <ContactTitle>Contactanos</ContactTitle>

          <ContactParagraph>
            <FontAwesomeIcon icon={faWhatsapp} color={"#32cd32"} />
            +54 9 11 5850-3232{" "}
          </ContactParagraph>
          <ContactParagraph>
            <FontAwesomeIcon icon={faWhatsapp} color={"#32cd32"} />
            +54 9 11 3071-0101
          </ContactParagraph>

          <ContactParagraph>
            <FontAwesomeIcon icon={faInstagram} color={"#E1306C"} />{" "}
            realcarsalquiler
          </ContactParagraph>
          <ContactParagraph>
            <FontAwesomeIcon icon={faEnvelope} /> contactorealcars@gmail.com
          </ContactParagraph>
        </ContactColumn>
        <ContactColumn>
          <ContactTitle>Dirección</ContactTitle>
          <LastParagraph>
            <FontAwesomeIcon icon={faLocationDot} />
            Av. Gral Paz 13124, CABA. Argentina.{" "}
          </LastParagraph>
          <CarLogo src="/images/auto.png" />
        </ContactColumn>

        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.560205584047!2d-58.51419478255616!3d-34.665808199999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcc8e323bd5e9f%3A0x451bfdcdcd0fc0aa!2sAv.%20Gral.%20Paz%2013124%2C%20C1440%20CABA!5e0!3m2!1ses!2sar!4v1664727745430!5m2!1ses!2sar"
          title="Real Cars"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </ContactUI>
    </>
  );
};

export default Contact;
